import palette from '../theme/palette';
import pxToRem from '../theme/pxToRem';

const styleOverrides = {
  root: {
    padding: '8px',
    // controlled by TableRow
    borderBottom: 'none',
    '& > svg': {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      color: palette.text.disabled,
    },
    '& > a': {
      color: palette.primary.main,
    },
    fontSize: pxToRem(14),
  },
  head: {
    color: palette.text.secondary,
    fontSize: pxToRem(12),
    lineHeight: 1.333333333,
    textTransform: 'uppercase',
  },
};

export default styleOverrides;
